import React from 'react';
interface PriceDisplayProps {
  amount: number;
  className?: string;
}
export function PriceDisplay({
  amount,
  className = ''
}: PriceDisplayProps) {
  const formattedAmount = new Intl.NumberFormat('es-AR').format(amount);
  return <span className={className} data-id="element-125">${formattedAmount}</span>;
}